import { DogIcon, ImageCircle } from '$components'
import { PetRoutePaths } from '../../routes/protected'
import { QueryParams, Router } from '$utils/router'
import { Text } from '$components'
import { Link } from 'react-router-dom'

export type PetCellProps = {
  data: {
    id: number
    name: string
    image?: string
  }
  query?: QueryParams
}

export function PetCell({ data, query }: PetCellProps) {
  return (
    <Link
      to={
        Router.buildRoute(Router.getRoute(PetRoutePaths.PetsView, { id: data.id.toString() }),
          PetRoutePaths.PetsDetails,
          query,
        )}
      onClick={(e) => e.stopPropagation()}
      className="relative z-[2] flex gap-stack-tight items-center border border-border w-fit rounded-pill py-stack-dense pl-stack-dense pr-stack-roomy hover:border-border-focus bg-surface transition-colors"
    >
      {data.image
        ? (
          <ImageCircle
            image={data.image}
            size="md"
          />
        )
        : (
          <div className="size-7 shrink-0 rounded-pill flex items-center justify-center bg-border">
            <DogIcon className="text-fg-disabled size-4" />
          </div>
        )}

      <Text type="s" className="text-nowrap truncate max-w-32">
        {data.name}
      </Text>
    </Link>
  )
}
